import React, { useRef, useState } from 'react';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
// Replace MUI icons with Heroicons
import { CloudArrowUpIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useTheme } from '@mui/material/styles';
const FileValidationEnum = require('../../../enums/FileValidityEnums');
const { FILE_SIZE_LIMIT, MAX_FILES_LIMIT, ALLOWED_FILE_TYPES } = FileValidationEnum;

const AttachmentUploadButton = ({ isUploading, handleAttachmentUpload }) => {
  const theme = useTheme();
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const syntheticEvent = { target: { files: files } };
      handleAttachmentUpload(syntheticEvent);
    }
  };

  return (
    <Box
      sx={{
        border: '2px dashed',
        borderColor: isDragging ? theme.palette.primary.main : '#cbd5e1',
        borderRadius: 2,
        background: '#fafbfc',
        p: 0,
        width: '100%',
        minHeight: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        transition: 'border-color 0.2s',
      }}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        multiple
        onChange={handleAttachmentUpload}
        style={{ display: 'none' }}
        id="attachment-upload"
      />
      <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: '#ede9fe',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
          }}>
            {/* Use Heroicons CloudArrowUpIcon */}
            <CloudArrowUpIcon style={{ color: '#7c3aed', width:26, height: 26 }} />
          </Box>
        </Box>
        <Typography variant="heading1" sx={{ mb: 0.5 }}>
          Drop files here or click to browse
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
          Support for images, PDFs, documents up to 5MB each
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            background: '#7c3aed',
            color: '#fff',
            fontWeight: 400,
            borderRadius: 2,
            px: 2,
            py: 0.8,
            fontSize: 16,
            boxShadow: 'none',
            '&:hover': { background: '#6d28d9' },
          }}
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          disabled={isUploading}
          startIcon={<PlusIcon style={{ width: 16, height: 16 }} />}
        >
          Choose Files
        </Button>
      </Box>
      {isUploading && (
        <Box sx={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
          <LinearProgress />
        </Box>
      )}
    </Box>
  );
};

export default AttachmentUploadButton;
